<template>
  <div>
    <header-portrate />
    <exports-print ref="exportbar" />

    <div>
      <bread-crumbs :items="items" />
      <tabs-comp :tabs="tabs" />

      <v-row class="mt-2 mb-2" style="margin-inline-start:2px;margin-inline-end:35px;">
        <v-col cols="12">
          <technical-inspection-reports-module />
        </v-col>
      </v-row>
    </div>

    <Footer />
  </div>
</template>

<script>
import HeaderPortrate from '@/components/Header-Portrate.vue';
import ExportsPrint from '@/components/exports-print.vue';
import breadCrumbs from '@/components/breadCrumbs.vue';
import TabsComp from '@/components/tabsComp.vue';
import Footer from '@/components/Footer.vue';
import TechnicalInspectionReportsModule from '@/n-compnents/TechnicalInspectionReportsModule.vue';

export default {
  name: 'TechnicalInspectionReportsView',
  components: {
    HeaderPortrate,
    ExportsPrint,
    breadCrumbs,
    TabsComp,
    Footer,
    TechnicalInspectionReportsModule
  },
  data() {
    return {
      items: [
        { text: 'التقارير', disabled: false, href: '' },
        { text: 'تقارير الفحص الفني', disabled: true, href: '' }
      ]
    };
  },
  computed: {
    lang() {
      if (this.$cookies.get(this.$store.state.LangCooki) != null) {
        if (this.$cookies.get(this.$store.state.LangCooki) == 'en') {
          return this.$store.state.lang.en;
        } else if (this.$cookies.get(this.$store.state.LangCooki) == 'ur') {
          return this.$store.state.lang.ur;
        } else {
          return this.$store.state.lang.ar;
        }
      }
      else if (this.$store.state.deflang == 'en') {
        return this.$store.state.lang.en;
      }
      else if (this.$store.state.deflang == 'ur') {
        return this.$store.state.lang.ur;
      }
      return this.$store.state.lang.ar;
    },
    tabs() {
      const menu = this.$store.getters['state'].menu;
      const license = this.$store.getters['state'].licenseType.activemenu;
      const alicense = this.$store.getters['state'].licenseType;
      let currentMenu = menu[license];
      if (!license) {
        return false;
      }

      let cMenu = { main: {}, sub: [] };
      Object.values(currentMenu).forEach((value) => {
        const cM = localStorage.getItem('currentMenu');
        if (value.main.index == cM) {
          cMenu = value.sub;
        } else if (cM == null && value.main.index == 1) {
          cMenu = value.sub;
        }
      });

      let t = [];
      Object.values(cMenu).forEach((value) => {
        if (this.$route.path == value.href) {
          value.class = 'mytab';
        } else {
          value.class = 'mytab4';
        }
        if (this.lang.langname == 'ar') {
          value.name = value.arname;
        } else {
          value.name = value.enname;
        }
        for (let i = 0; i < value.groupid.length; i++) {
          if (value.groupid[i] == this.$store.getters['state'].group_id) {
            if (alicense[value.perms[0]] || value.perms[0] == 'any') t.push(value);
          }
        }
      });

      return t;
    }
  }
};
</script>
